import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconTranslate = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 32 32"
    data-fill-none
  >
    <path
      d="M16.913 21H24.087M16.913 21L15 25M16.913 21L19.7783 15.009C20.0092 14.5263 20.1246 14.2849 20.2826 14.2086C20.4199 14.1423 20.5801 14.1423 20.7174 14.2086C20.8754 14.2849 20.9908 14.5263 21.2217 15.009L24.087 21M24.087 21L26 25M6 9H12M12 9L15.5 9M12 9V7M15.5 9H18M15.5 9C15.0039 11.9573 13.8526 14.6362 12.1655 16.8844M14 18C13.3875 17.7248 12.7626 17.3421 12.1655 16.8844M12.1655 16.8844C10.813 15.8478 9.60276 14.4266 9 13M12.1655 16.8844C10.5609 19.0229 8.47143 20.7718 6 22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconTranslate.displayName = 'IconTranslate';
